// Register the custom element
if (!customElements.get('products-list')) {
  // Define ProductsList custom element
  class ProductsList extends HTMLElement {
    constructor() {
      super();
      this.handle = '';
    }

    connectedCallback() {
      this.initializeActiveTab();
      this.initializeSwiper();
    }

    initializeActiveTab() {
      const activeTab = this.querySelector('.active-tab');
      if (activeTab) {
        this.handle = activeTab.getAttribute('tab-title') || '';
      }
    }

    initializeSwiper() {
      const swiperEl = this.querySelector('[product-wrap] swiper-container');
      if (!swiperEl) return;

      // Wait for swiper to be defined
      const waitForSwiper = (callback, attempts = 0) => {
        if (attempts > 50) {
          console.warn('Swiper initialization timeout');
          return;
        }

        // Check if swiper is ready
        if (swiperEl.swiper && swiperEl.swiper.initialized) {
          callback();
        } else {
          // Initialize if not initialized
          if (typeof swiperEl.initialize === 'function') {
            swiperEl.initialize();
          }
          // Retry after a short delay
          setTimeout(() => waitForSwiper(callback, attempts + 1), 100);
        }
      };

      waitForSwiper(() => {
        this.initializeCustomNavigation(swiperEl);
      });
    }

    initializeCustomNavigation(swiperElement) {
      const swiperContainer = swiperElement.closest('[product-wrap]');
      if (!swiperContainer) {
        console.warn('Swiper container not found');
        return;
      }

      const prevButton = swiperContainer.querySelector('[data-swiper-prev]');
      const nextButton = swiperContainer.querySelector('[data-swiper-next]');

      if (!prevButton || !nextButton) {
        console.warn('Navigation buttons not found');
        return;
      }

      // Get swiper instance
      const swiperInstance = swiperElement.swiper;
      if (!swiperInstance) {
        console.warn('Swiper instance not found');
        return;
      }

      // Update button states
      const updateNavigationState = () => {
        // Check if at beginning
        if (swiperInstance.isBeginning) {
          prevButton.classList.add('swiper-button-disabled');
          prevButton.setAttribute('aria-disabled', 'true');
        } else {
          prevButton.classList.remove('swiper-button-disabled');
          prevButton.setAttribute('aria-disabled', 'false');
        }

        // Check if at end
        if (swiperInstance.isEnd) {
          nextButton.classList.add('swiper-button-disabled');
          nextButton.setAttribute('aria-disabled', 'true');
        } else {
          nextButton.classList.remove('swiper-button-disabled');
          nextButton.setAttribute('aria-disabled', 'false');
        }
      };

      // Remove any existing listeners
      const newPrevButton = prevButton.cloneNode(true);
      const newNextButton = nextButton.cloneNode(true);
      prevButton.parentNode.replaceChild(newPrevButton, prevButton);
      nextButton.parentNode.replaceChild(newNextButton, nextButton);

      // Bind click events to new buttons
      newPrevButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!newPrevButton.classList.contains('swiper-button-disabled')) {
          swiperInstance.slidePrev();
          updateNavigationState();
        }
      });

      newNextButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!newNextButton.classList.contains('swiper-button-disabled')) {
          swiperInstance.slideNext();
          updateNavigationState();
        }
      });

      // Listen for slide changes
      swiperInstance.on('slideChange', updateNavigationState);
      swiperInstance.on('reachBeginning', updateNavigationState);
      swiperInstance.on('reachEnd', updateNavigationState);
      swiperInstance.on('fromEdge', updateNavigationState);
      swiperInstance.on('toEdge', updateNavigationState);

      // Initial state
      updateNavigationState();
    }
  }
  customElements.define('products-list', ProductsList);
}